import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FiFile } from 'react-icons/fi';
import { connect } from 'react-redux';
import { compose, lifecycle } from "recompose";
import { bindActionCreators } from 'redux';
import { dateFormats } from '../../../../../constants';
import { userActions } from '../../../../../state/modules/user';
import { GeneralTable } from '../../../../components';

const columns = [
  {
    key: 'date',
    name: ''
  },
  {
    key: 'amount',
    name: ''
  },
  {
    key: 'status',
    name: ''
  },
  {
    key: 'actions',
    name: 'Download PDF'
  }
]

const parseAmount = (amount) => {
  const dollars = Math.floor(amount / 100)

  const cents = amount % 100
  return `$${dollars}.${cents > 9 ? cents : `0${cents}`}`
}

const Invoices = ({ invoices }) => {
  const rows = fp.map(
    ({ date, amountDue, paid, invoicePdf }) => {
      return {
        date: {
          value: dateFnsCompat.format(date, dateFormats.ShortDate)
        },
        amount: {
          value: parseAmount(amountDue)
        },
        status: {
          value: paid ? 'Paid' : 'Pending'
        },
        actions: {
          className: 'actions',
          value: <div>
            {
              invoicePdf ?
                <a className='download-pdf flexbox vertical' href={invoicePdf} target='_blank'>
                  <FiFile />
                </a> : null
            }
          </div>
        }
      }
    }
  )(invoices)
  return (
    <div id='invoices'>
      <Row className="no-gutter">
        <Col>
          <h2>Your Invoices</h2>
        </Col>
        <Col>
          <GeneralTable className='invoices-table' columns={columns} rows={rows} />
        </Col>
      </Row>
    </div>
  )
}

const mapStateToProps = (state) => ({
  invoices: state.user.invoices
})
const mapDispatchToProps = (dispatch) => ({
  getInvoices: bindActionCreators(userActions.user.getInvoices, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const { getInvoices } = this.props
      getInvoices()
    }
  })
)(Invoices)


// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/partials/invoices.js